import { render } from "./NotificationList.vue?vue&type=template&id=73099e44&scoped=true"
import script from "./NotificationList.vue?vue&type=script&lang=js"
export * from "./NotificationList.vue?vue&type=script&lang=js"

import "./NotificationList.vue?vue&type=style&index=0&id=73099e44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73099e44"]])

export default __exports__